import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
import { axCoerceString } from '@awayjs/graphics';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: FrameLabel
var FrameLabel = /** @class */ (function (_super) {
    __extends(FrameLabel, _super);
    function FrameLabel(name, frame /*int*/) {
        var _this = _super.call(this) || this;
        _this._name = axCoerceString(name);
        _this._frame = frame | 0;
        return _this;
    }
    Object.defineProperty(FrameLabel.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FrameLabel.prototype, "frame", {
        get: function () {
            return this._frame;
        },
        enumerable: true,
        configurable: true
    });
    FrameLabel.prototype.clone = function () {
        return new FrameLabel(this._name, this._frame);
    };
    // Called whenever the class is initialized.
    FrameLabel.classInitializer = null;
    return FrameLabel;
}(EventDispatcher));
export { FrameLabel };
